import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const pageTitles = {
  "/": "Home",
  "/menu": "Menu",
  "/menu/hot-desserts": "Menu - Hot Desserts",
  "/booktable": "Book a Table",
  "/slushees": "Slushees",
  "/apply": "Apply",
  "/partner": "Tubbees Express",
  "/app": "Get the App",
  "/find-us": "Find Us",
};

export default function PageTitle() {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  const title = pageTitles[path] || "Page Not Found";

  useEffect(() => {
    document.title = `Tubbees | ${title}`;
  }, [title]);

  return null;
}
